import { render, staticRenderFns } from "./ModDetail.vue?vue&type=template&id=a8774ec6"
import script from "./ModDetail.vue?vue&type=script&lang=js"
export * from "./ModDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports